// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

export enum OrderLinkType {
    ORDER_LINK_NONE = -1,
    // use to bound OCO orders:
    ORDER_LINK_CANCEL = 0,
    // use to build execution chain:
    ORDER_LINK_EXECUTE_AFTER = 1
}
